import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerticalBarsStacked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M63.543 213.624h42.553v-84.545H63.543z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M63.543 134.583h42.542V48.014c0-6.714-5.443-12.158-12.158-12.158H75.701c-6.715 0-12.158 5.444-12.158 12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M130.418 213.624h42.553v-58.159h-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M130.418 170.483h42.542v-68.618c0-6.715-5.443-12.158-12.158-12.158h-18.226c-6.715 0-12.158 5.443-12.158 12.158z"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M197.293 213.64h42.553v-72.948h-42.553z"
      clipRule="evenodd"
    />
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M197.293 143.558h42.542V74.94c0-6.715-5.443-12.158-12.158-12.158h-18.226c-6.715 0-12.158 5.443-12.158 12.158z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerticalBarsStacked;
